<template>
    <CompassDialog
        :visible.sync="showModal"
        size="small"
        :title="
            toActivate
                ? $t.__('popups.Corp2FAToggle.activate_company_dual_authentication')
                : $t.__('popups.Corp2FAToggle.disable_company_dual_authentication')
        "
        class="corp2FAToggle"
        @closed="close"
    >
        <template slot="default">
            <div class="dialog__default">
                <template v-if="toActivate">
                    <p class="typographies-paragraph-medium-semibold m-0 mb-2">
                        {{
                            $l10n.__(
                                "En activant la double authentification sur l'ensemble des comptes collaborateurs de votre société, la sécurité va être renforcée.",
                            )
                        }}
                    </p>
                    <p class="m-0 mb-3 typographies-paragraph-medium-regular">
                        {{
                            $l10n.__(
                                "Lors de la prochaine connexion de chacun de vos collaborateurs, il leur sera demandé de choisir une méthode d'authentification afin de finaliser l'activation de la double authentification sur leur compte",
                            )
                        }}
                    </p>
                </template>

                <template v-else>
                    <p class="typographies-paragraph-medium-semibold m-0 mb-2">
                        {{
                            $l10n.__(
                                "En désactivant la double authentification sur l'ensemble des comptes collaborateurs de votre société, la sécurité ne sera plus renforcée.",
                            )
                        }}
                    </p>
                    <p class="m-0 mb-3 typographies-paragraph-medium-regular">
                        {{
                            $l10n.__(
                                "Lors de la prochaine connexion non reconnue de chacun de vos collaborateurs, il ne leur plus sera demandé un code de sécurité sur la méthode d'authentification configurée.",
                            )
                        }}
                    </p>
                </template>
                <p class="m-0 gray-60 typographies-paragraph-medium-regular">
                    {{ $l10n.__("Besoin d'aide ?") }}
                    <a
                        href="https://help.sellsy.com/fr/articles/6178777-comment-fonctionne-la-double-authentification"
                        target="_blank"
                    >
                        <span class="bold">{{ $l10n.__('Consulter notre page dédiée.') }}</span>
                    </a>
                </p>
            </div>
        </template>
        <template slot="footer">
            <div class="dialog__footer">
                <CompassButton
                    :label="$t.__('common.actions.cancel')"
                    type="secondary"
                    size="medium"
                    @click="close"
                />
                <CompassButton
                    v-if="toActivate"
                    :label="$t.__('popups.Corp2FAToggle.activate_dual_authentication')"
                    type="primary"
                    :loading="loading"
                    class="ml-3"
                    @click="save(true)"
                />
                <CompassButton
                    v-else
                    :label="$t.__('popups.Corp2FAToggle.disable_dual_authentication')"
                    type="primary-destructive"
                    :loading="loading"
                    class="ml-3"
                    @click="save(false)"
                />
            </div>
        </template>
    </CompassDialog>
</template>

<script>
export default {
    props: {
        toActivate: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            showModal: true,
            loading: false,
        };
    },
    methods: {
        save(enabled) {
            this.loading = true;
            ApiClient.put('/settings/two-factor-authentication', {}, { enabled })
                .then((response) => {
                    Push.success(
                        response.data.enabled
                            ? this.$l10n.__('Double authentification activée')
                            : this.$l10n.__('Double authentification désactivée'),
                    );
                })
                .catch(() => {
                    Push.error(this.$l10n.__('Une erreur est survenue'));
                })
                .finally(() => {
                    this.$emit('close');
                });
        },
        close() {
            const parent = document.querySelector('#corp2FAToggle');
            const child = parent.querySelector('[type="checkbox"]');

            if (parent) {
                parent.classList.toggle('form-toggle-on');
                parent.classList.toggle('form-toggle-off');
                child.checked = !child.checked;
            }
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@sellsy/styleguide/src/_variables';
.corp2FAToggle {
    .dialog {
        &__default {
            padding-bottom: 24px;
        }

        &__footer {
            display: flex;
            justify-content: flex-end;
            padding: 0 32px 24px 32px;
        }
    }

    a {
        &:hover {
            color: $primary-100;
        }
    }
}
</style>
